export default __webpack_public_path__ + "static/media/weather_image.4cb24253.png";